import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip } from 'react-wot-bootstrap'

import {
    TOOLTIP_FOOTER,
    TOOLTIP_BACK_FOOTER,
    TOOLTIP_FOOTER_REBUILD,
} from '../../constants.jsx'
import {
    FORT_BATTLE_TOOLTIP_TITLE,
    FORT_BATTLE_TOOLTIP_BONUS,
    FORT_BATTLE_TOOLTIP_ENGAGED,
    FORT_BATTLE_TOOLTIP_SELECTED,
} from './constants.jsx'

import styles from './FortBattleTooltip.scss'

const FortBattleTooltip = (props) => {
    const bonusMessage = !props.bonus ? null : (
        <div className={styles.ribbon}>
            <p className={styles.bonus}>
                <span className={styles.icon}>{'x2'}</span>
                {FORT_BATTLE_TOOLTIP_BONUS}
            </p>
        </div>
    )

    let footer
    if (props.isSelected) {
        footer = TOOLTIP_BACK_FOOTER
    } else if (props.isRebuild) {
        footer = TOOLTIP_FOOTER_REBUILD
    } else {
        footer = TOOLTIP_FOOTER
    }

    return (
        <Tooltip id={props.tooltipId}>
            <div className={styles.content}>
                <h3 className={styles.title}>{FORT_BATTLE_TOOLTIP_TITLE(props.direction)}</h3>
                {
                    props.isSelected &&
                    <div>
                        <p className={styles.selected}>{FORT_BATTLE_TOOLTIP_SELECTED}</p>
                        <div className={styles.divider}/>
                        <p className={styles.footer}>{footer}</p>
                    </div>
                }
                {
                    !props.isSelected &&
                    <div>
                        {bonusMessage}
                        {props.battle ?
                            <p className={styles.engaged}>{FORT_BATTLE_TOOLTIP_ENGAGED}</p> :
                            <p className={styles.footer}>{footer}</p>
                        }
                    </div>
                }
            </div>
        </Tooltip>
    )
}

FortBattleTooltip.propTypes = {
    tooltipId: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    bonus: PropTypes.bool,
    battle: PropTypes.bool,
    isSelected: PropTypes.bool,
    isRebuild: PropTypes.bool,
}

export default FortBattleTooltip



// WEBPACK FOOTER //
// ./components/BattleWizard/components/FortBattleTooltip/FortBattleTooltip.jsx